<template>
<div class="signup">
    <h1 class="subheading grey--text">Opret bruger</h1>
    <v-layout row wrap>
        <v-flex xs12 sm6 md4>
            <v-form class="px-3" ref="form">
                <v-text-field label="Navn" v-model="name" :rules="nameRules"></v-text-field>
                <v-text-field label="E-mail" v-model="email" :rules="emailRules"></v-text-field>
                <v-text-field label="Password" :type="show1 ? 'text' : 'password'" v-model="password" :rules="passwordRules" :append-icon="show1 ? 'visibility_off' : 'visibility'" @click:append="show1 = !show1">
                </v-text-field>
                <v-text-field label="Gentag password" :type="show1 ? 'text' : 'password'" v-model="passwordConfirm" :rules="passwordRules" :append-icon="show1 ? 'visibility_off' : 'visibility'" @click:append="show1 = !show1">
                </v-text-field>
                <v-text-field label="Godkendelseskode" v-model="secretKeyInput" v-if="signupWithCode"></v-text-field>
                <v-switch label="Indtast godkendelseskode" v-model="signupWithCode"></v-switch>

                <v-alert v-model="showAlert" color="error">
                    {{message}}.
                </v-alert>
                <v-spacer></v-spacer>
                <v-btn flat class="success " @click="submit" :loading="loading">Opret bruger</v-btn>
                <v-spacer></v-spacer>
                <v-divider class="margins"></v-divider>
                <v-bottom-sheet inset>
                    <v-btn slot="activator" flat small color="grey">
                        Hvad er godkendelseskode?
                    </v-btn>

                    <v-card>
                        <v-progress-linear :value="100" class="my-0" height="3"></v-progress-linear>
                        <v-flex xs12 pa-4>
                            <div class="grey--text--darken-4">Godkendelseskode anvendes til at aktivere din konto. Aktivering er nødvendigt for at kunne oprette foldreservationer. Koden kan fås ved at kontakte kontoret. Du kan godt oprette dig uden at kende koden og så aktivere kontoen på "Min side" når du har fået koden.</div>
                        </v-flex>
                    </v-card>
                </v-bottom-sheet>

            </v-form>
        </v-flex>
    </v-layout>

</div>
</template>

<script>
import format from 'date-fns/format'
import firebase from 'firebase'
export default {
    data() {
        return {
            show1: false,
            //signupWithoutCode: true,
            signupWithCode: false,
            secretKeyInput: '',
            email: '',
            name: '',
            password: '',
            passwordConfirm: '',
            message: '',
            showAlert: false,
            loading: false,
            emailRules: [
                v => !!v || "E-mail skal udfyldes",
                v =>
                /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                "E-mail skal være korrekt"
            ],
            passwordRules: [v => !!v || "Password skal udfyldes"],
            nameRules: [
                v => v.length >= 2 || 'Navn skal være mindst 2 tegn',
            ],
        }
    },
    computed: {

        secretKey() {
            return this.$store.getters.secretKey
        },
    },
    created() {
        //this.signupWithCode = !this.signupWihoutCode 

    },
    methods: {
        submit() {
            let codeOK = false
            if (this.$refs.form.validate()) {
                if (this.password != this.passwordConfirm) {
                    this.showAlert = true;
                    this.message = "Passwords er ikke ens";

                } else {
                    this.showAlert = false;
                    this.message = '';
                    this.loading = true;
                    //console.log('this.$store.state.config.secretKey' + this.$store.state.config.secretKey)
                    //console.log('this.secretKeyInput' +this.secretKeyInput)
                    if (this.$store.getters.config.secretKey.localeCompare(this.secretKeyInput) === 0) {
                        codeOK = true
                        //console.log('code ok')
                    } else {
                        this.loading = false;
                    }
                    //console.log('codeOKe '+ codeOK + 'this.signupWithCode ' + this.signupWithCode)
                    if (codeOK || !this.signupWithCode) {
                        firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
                            .then(cred => {

                                const user = {
                                    name: this.name,
                                    user_id: cred.user.uid,
                                    admin: false,
                                    approved: codeOK,
                                    active: true,
                                    created: format(Date.now(), 'YYYY-MM-DD')

                                }
                                const db = this.$firebase.firestore()
                                db.collection('users').add(user).then(() => {
                                    this.loading = false;
                                    this.$emit('userAdded');
                                    //console.log('db add ')
                                })
                                //cred.user.sendEmailVerification().then(function() {
                                // Email sent.
                                //}).catch(function(error) {
                                // An error happened.
                                //    console.log(error)
                                //});                            
                            }).then(() => {

                                this.$store.dispatch('setAuthUser').then(() => {
                                    if (firebase.auth().currentUser) {
                                        this.$store.dispatch('setProfile', {
                                            vm: this
                                        })
                                        //console.log('dispatch setProfile ')
                                    }
                                })
                                this.$router.push({
                                    name: 'dashboard'
                                })
                            })
                            .catch(err => {
                                this.showAlert = true;
                                this.message = err.message;
                                this.loading = false;
                            })
                    }
                }

            }
        }
    }
}
</script>

  
<style>
.normal-case {
    background-color: #4267b2;
    text-transform: none;
}

.margins {
    margin-top: 30px;
    margin-bottom: 20px;
}
</style>
